<div class="card mb-4">
  <h3 class="green decoration mb-4">
    <span *ngIf="id == undefined">Crear nuevo usuario</span>
    <span *ngIf="id != undefined">Editar usuario</span>
  </h3>
  <div class="row flex">
    <div class="col-lg-12">
      <!-- <div [formGroup]="branchForm" >
        <div *ngIf="id != undefined">
          <div class="row">
            <div class="col-lg-4">
              <div class="form-wrapper mb-3">
                <span>Sucursal:</span>
                <select (change)="setBranch()" formControlName="branch">
                  <option *ngFor="let branch_office of branch_offices" [value]="branch_office.id_br">{{ branch_office.name_branch_office }}</option>
                </select>
              </div>
            </div>
          </div>
          <hr>
        </div>
      </div> -->
      <div [formGroup]="newUserForm">
        <div class="row">
          <div class="col-lg-4">
            <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('first_name').dirty && newUserForm.get('first_name').invalid">
              <span>Nombres*</span>
              <input type="text" formControlName="first_name" placeholder="Ej: Sergio Miguel">
              <p *ngIf="newUserForm.get('first_name').dirty && newUserForm.get('first_name').invalid">
                <img src="../../../assets/img/x-circle.svg" alt="icon">
                <label *ngIf="newUserForm.get('first_name').errors.required">Este campo es necesario</label>
              </p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('last_name').dirty && newUserForm.get('last_name').invalid">
              <span>Apellidos*</span>
              <input type="text" formControlName="last_name" placeholder="Ej: Luján Mora">
              <p *ngIf="newUserForm.get('last_name').dirty && newUserForm.get('last_name').invalid">
                <img src="../../../assets/img/x-circle.svg" alt="icon">
                <label *ngIf="newUserForm.get('last_name').errors.required">Este campo es necesario</label>
              </p>
            </div>
          </div>
          <!-- <div class="col-lg-4">
            <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('username').dirty && newUserForm.get('username').invalid">
              <span>Nombre de usuario*</span>
              <input type="text" formControlName="username" placeholder="Ej: SerMora254">
              <p *ngIf="newUserForm.get('username').dirty && newUserForm.get('username').invalid">
                <img src="../../../assets/img/x-circle.svg" alt="icon">
                <label *ngIf="newUserForm.get('username').errors.required">Este campo es necesario</label>
              </p>
            </div>
          </div> -->

          <div class="col-lg-4">
            <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('email').dirty && newUserForm.get('email').invalid">
              <span>Correo electrónico*</span>
              <input type="email" formControlName="email" placeholder="Ej: ejemplo@email.com">
              <p *ngIf="newUserForm.get('email').dirty && newUserForm.get('email').invalid">
                <img src="../../../assets/img/x-circle.svg" alt="icon">
                <label *ngIf="newUserForm.get('email').errors.required">Este campo es necesario</label>
                <label *ngIf="newUserForm.get('email').errors.required && newUserForm.get('email').errors.email">,</label>
                <label *ngIf="newUserForm.get('email').errors.email">Este campo no es valido</label>
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('cellphone').dirty && newUserForm.get('cellphone').invalid">
              <span>Teléfono</span>
              <input type="number" formControlName="cellphone" placeholder="Ej: 61234789">
              <p *ngIf="newUserForm.get('cellphone').dirty && newUserForm.get('cellphone').invalid">
                <img src="../../../assets/img/x-circle.svg" alt="icon">
                <label *ngIf="newUserForm.get('cellphone').errors.required">Este campo es necesario</label>
              </p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('role').dirty && newUserForm.get('role').invalid">
              <span>Rol*</span>
              <!-- <select formControlName="role">
                <option value="">Seleccione una opción</option>
                <option *ngFor="let rol of roles" [value]="rol.id">{{ rol.name | titlecase }}</option>
              </select> -->

              <!-- <mat-select formControlName="role" placeholder="Seleccione una opción" multiple>
                  <mat-option *ngFor="let role of roles" [value]="role.role_id">{{ role.role_name | titlecase }}</mat-option>
              </mat-select> -->

              <mat-select (click)="setFocus('matInput1')" formControlName="role" placeholder="Seleccione una opción">
                <ng-container *ngIf="roles; else elseRoles">
                  <div class="filter_option">
                    <input placeholder="Buscar..." [(ngModel)]="filterTerm" class="!outline-none" [ngModelOptions]="{standalone: true}" id="matInput1">
                  </div>
                  <mat-option value="">Todos</mat-option>
                  <mat-option *ngFor="let role of roles | filter: filterTerm; let i = index" [value]="role.role_id">{{ role.display_name }}</mat-option>
                </ng-container>
                <ng-template #elseRoles>
                  <mat-option value="">No se encontraron resultados...</mat-option>
                </ng-template>
              </mat-select>

              <p *ngIf="newUserForm.get('role').dirty && newUserForm.get('role').invalid">
                <img src="../../../assets/img/x-circle.svg" alt="icon">
                <label *ngIf="newUserForm.get('role').errors.required">Este campo es necesario</label>
              </p>
            </div>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-lg-4">
            <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('gender').dirty && newUserForm.get('gender').invalid">
              <span>Genero:</span>
              <mat-select formControlName="gender" placeholder="Seleccione una opción">
                <ng-container *ngIf="genders; else elseGenders">
                  <div class="filter_option">
                    <input placeholder="Buscar..." [(ngModel)]="filterTerm2" class="!outline-none" [ngModelOptions]="{standalone: true}">
                  </div>
                  <mat-option value="">Todos</mat-option>
                  <mat-option *ngFor="let gender of genders | filter: filterTerm2; let i = index" [value]="gender.value">{{ gender.name }}</mat-option>
                </ng-container>
                <ng-template #elseGenders>
                  <mat-option value="">No se encontraron resultados...</mat-option>
                </ng-template>
              </mat-select>
              <select formControlName="gender">
                <option value="">Seleccione una opción</option>
                <option *ngFor="let gender of genders" [value]="gender.value">{{ gender.name }}</option>
              </select>
              <p *ngIf="newUserForm.get('gender').dirty && newUserForm.get('gender').invalid">
                <img src="../../../assets/img/x-circle.svg" alt="icon">
                <label *ngIf="newUserForm.get('gender').errors.required">Este campo es necesario</label>
              </p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('ci').dirty && newUserForm.get('ci').invalid">
              <span>CI:</span>
              <input type="number" formControlName="ci" placeholder="Ej: 22134459">
              <p *ngIf="newUserForm.get('ci').dirty && newUserForm.get('ci').invalid">
                <img src="../../../assets/img/x-circle.svg" alt="icon">
                <label *ngIf="newUserForm.get('ci').errors.required">Este campo es necesario</label>
              </p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('status').dirty && newUserForm.get('status').invalid">
              <span>Estado:</span>
              <mat-select formControlName="status" placeholder="Seleccione una opción">
                <ng-container *ngIf="userStatuses; else elseUserStatuses">
                  <div class="filter_option">
                    <input placeholder="Buscar..." [(ngModel)]="filterTerm" class="!outline-none" [ngModelOptions]="{standalone: true}">
                  </div>
                  <mat-option value="">Seleccione una opción</mat-option>
                  <mat-option *ngFor="let userStatus of userStatuses | filter: filterTerm; let i = index" [value]="userStatus.value">{{ userStatus.name }}</mat-option>
                </ng-container>
                <ng-template #elseUserStatuses>
                  <mat-option value="">No se encontraron resultados...</mat-option>
                </ng-template>
              </mat-select>
              <select formControlName="status">
                <option value="">Seleccione una opción</option>
                <option *ngFor="let userStatus of userStatuses" [value]="userStatus.value">{{ userStatus.name }}</option>
              </select>
              <p *ngIf="newUserForm.get('status').dirty && newUserForm.get('status').invalid">
                <img src="../../../assets/img/x-circle.svg" alt="icon">
                <label *ngIf="newUserForm.get('status').errors.required">Este campo es necesario</label>
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('password').dirty && newUserForm.get('password').invalid">
              <span *ngIf="id == undefined">Contraseña:</span>
              <span *ngIf="id != undefined">Nueva Contraseña:</span>
              <div class="password-wrapper">
                <input id="hide-input" type="password" formControlName="password" placeholder="Ej: %Ser564">
                <div class="hide-wrapper" [ngClass]="{'hide': attrHide}" (click)="hidePass()">
                  <img src="../../../assets/img/qh-suite/eye.svg" alt="icon">
                </div>
              </div>
              <p *ngIf="newUserForm.get('password').dirty && newUserForm.get('password').invalid">
                <img src="../../../assets/img/x-circle.svg" alt="icon">
                <label *ngIf="newUserForm.get('password').errors.required">Este campo es necesario</label>
              </p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('password_check').dirty && newUserForm.get('password_check').invalid">
              <span *ngIf="id == undefined">Confirmar contraseña:</span>
              <span *ngIf="id != undefined">Antigua contraseña :</span>
              <div class="password-wrapper">
                <input id="hide-input-repeat" type="password" formControlName="password_check" placeholder="Ej: %Ser564">
                <div class="hide-wrapper" [ngClass]="{'hide': attrHide}" (click)="hidePass()">
                  <img src="../../../assets/img/qh-suite/eye.svg" alt="icon">
                </div>
              </div>
              <p *ngIf="newUserForm.get('password_check').dirty && newUserForm.get('password_check').invalid">
                <img src="../../../assets/img/x-circle.svg" alt="icon">
                <label *ngIf="newUserForm.get('password_check').errors.required">Este campo es necesario</label>
              </p>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>
<div class="table-title">
<!-- <button class="btn btn-outline-primary big">Limpiar datos</button> -->
&nbsp;
<div class="title-form-wrapper justify-end">
  <!-- <button (click)="previousStep()" class="btn btn-gray big">Anterior</button> -->
  <button (click)="createEditUser()" class="btn btn-primary big">
    <span *ngIf="id == undefined">Crear usuario</span>
    <span *ngIf="id != undefined">Guardar usuario</span>
  </button>
</div>
</div>

